module.exports = __webpack_public_path__ + "img/VW.7860aa30.png";